/* loaded by smart-asset */
export default require("./docstampt-badge~JFGQdaHr.png")